/**
 * 🟥 CUADRO NEGRO API Insights v5 (feb-2026) — hook Narrativa + RAG.
 */
import { useEffect, useState } from "react";
import { fetchInsightsV5 } from "../services/insightsV5Service";

export function useInsightsV5(userId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const d = await fetchInsightsV5(userId);
      setData(d);
      setLoading(false);
    }
    load();
  }, [userId]);

  return { data, loading };
}
